import React, {Component} from 'react';
import {Empty, Table, Tabs} from "antd";
import { get } from 'lodash';
import '../../components/Exchange';
import consts, {PREFIX_FRONT_URL} from '../../consts';
import {Translation} from "react-i18next";
import utils from "../../common/utils";

const {TabPane} = Tabs;

let prices = {};

// use for cache price when price not change price
const PriceComponent = React.memo(({ lastPrice, market }) => {
    let previousLastPrice = get(prices, `last${market.coin}_${market.currency}`, lastPrice);
    return <div
      style={{color: previousLastPrice > lastPrice ? '#3f8600' : previousLastPrice < lastPrice ? '#cf1322' : 'rgba(0, 0, 0, 0.65)'}}>
      {utils.formatCurrency(prices[`last${market.coin}_${market.currency}`] = lastPrice)}
    </div>
  }
)

class CoinMarket extends Component {
  columns = [
    {
      title: 'Coin',
      width: 100,
      dataIndex: 'coin',
      key: 'coin',
      className: 'text-left',
      render: (coin) => `${coin}`.toUpperCase(),
    },
    {
      title: <div className="text-right">Price</div>,
      width: 100,
      dataIndex: 'last_price',
      key: 'last_price',
      className: 'text-left',
      render: (lastPrice, market) => <div style={{...(market.style || {})}}>
        {lastPrice}
      </div>
    },
    {
      title: <div className="text-left">Volume</div>,
      width: 100,
      dataIndex: 'volume',
      key: 'volume',
      className: 'text-left',
    },
    {
      title: <div className="text-left">Change</div>,
      width: 100,
      dataIndex: 'change',
      key: 'change',
      className: 'text-left',
      render: (change) => <div
        style={{color: window._.get(this.props.data, 'change', 0) > 0 ? '#3f8600' : '#cf1322'}}>{change}</div>
    },
    {
      title: 'Name',
      width: 100,
      dataIndex: 'coin',
      key: 'coin',
      className: 'text-left',
      render: (coin) => <div>{window._.get(this.props.setting.coins[`${coin}`], 'name', '')}</div>
    }
  ];
  
  columnsLandingPage = (t, coins) => [
    {
      
      title: <div className="text-left-header">{t('landing.name')}</div>,
      width: 600,
      dataIndex: 'coin',
      key: 'coin',
      className: 'text-left',
      render: (coin) => {
        return <div className="d-flex align-items">
          <div style={{width: "15%", textAlign: "left"}}>
            <div style={{
              backgroundImage: `url(${coins[coin]?.icon_image})`, height: '31px',
              width: '31px',
              backgroundSize: 'contain',
              marginRight: "20px",
              display: 'block',
              backgroundRepeat: 'no-repeat'
            }} alt={coin}></div>
          
          </div>
          <div style={{
            width: "20%",
            textAlign: "left",
            fontWeight: 600,
            color: '#000',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            overflow: 'hidden',}}>{coin}</div>
          <div style={{
            width: "65%",
            textAlign: "left",
            fontSize: "18px",
            lineHeight: "28px",
            color: "#76808F",
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
          }}>{coins[coin]?.name ?? ''}</div>
        </div>
      }
    },
    {
      title: <div className="text-left-header">{t('landing.last_price')}</div>,
      width: 240,
      dataIndex: 'last_price',
      key: 'last_price',
      className: 'text-left',
      render: (lastPrice, market) => <PriceComponent lastPrice={lastPrice} market={market} />
    },
    {
      title: <div className="text-left-header">{t('landing.change_24h')}</div>,
      width: 240,
      dataIndex: 'change',
      key: 'change',
      className: 'text-left',
      render: (change) => <div
        style={{color: change >= 0 ? '#3f8600' : '#cf1322'}}>{change} %</div>
    },
    {
      title: <div className="text-left-header">{t('landing.high')}</div>,
      width: 240,
      dataIndex: 'high',
      key: 'high',
      className: 'text-left',
      render: (high) => <div>{utils.formatCurrency(high)}</div>
    },
    {
      title: <div className="text-left-header">{t('landing.low')}</div>,
      width: 240,
      dataIndex: 'low',
      key: 'low',
      className: 'text-left',
      render: (low) => <div>{utils.formatCurrency(low)}</div>
    },
    {
      title: <div className="text-left-header">{t('landing.volume')}</div>,
      width: 240,
      dataIndex: 'volume',
      key: 'volume',
      className: 'text-left',
      render: volume => <div>{utils.formatCurrency(volume)}</div>
      // return <Spring
      // 	from={{number: this.previousVolume }}
      // 	to={{number: this.previousVolume = volume }}>
      // 	{props => <div>{utils.formatCurrency(props.number)}</div>}
      // </Spring>
    },
  ];
  
  
  render() {
    return (
      <Translation>
        {(t) => <div className="open-order-wrap">
          <Tabs type="card" style={{textAlign: 'left'}} tabBarGutter={5} tabBarStyle={{
            borderWidth: 0,
            borderColor: '#FFFFFF',
            borderBottomWidth: 2,
            borderStyle: 'solid',
            paddingLeft: 0,
            marginBottom: 0,
            fontWeight: 500,
          }}>
            {
              window._.map(this.props.setting.currencyMarkets, (markets, currency) => {
                  if (currency !== 'all') {
                    return <TabPane tab={<div style={{width: 88}}>
                      {`${currency}`.toUpperCase()}
                    </div>} key={currency}>
                      <Table locale={{
                        emptyText: (<Empty description={<span className="bold">{window.$t('common.empty')}</span>}/>)
                      }}
                             columns={!!this.props.isLandingPage ? this.columnsLandingPage(t, this.props.coins) : this.columns}
                             rowClassName="pointer"
                             onRow={({coin, currency}) => {
                               return {
                                 onClick: () => {
                                   window._.get(this.props, 'changeMarket', () => {
                                   })(coin, currency);
                                   this.props.history.push(`${PREFIX_FRONT_URL}/?currency=${coin}/${currency}`);
                                 }
                               };
                             }}
                             style={{maxWidth: consts.MAX_WIDTH, overflow: 'auto'}}
                             scroll={false}
                             pagination={false}
                             dataSource={[...markets || []]}
                             className="mb-large"
                      />
                    </TabPane>
                  }
                }
              )
            }
          </Tabs>
        </div>}
      </Translation>
    );
  }
}

export default CoinMarket;
